import { BasePresenter } from "@presenters/base/base.presenter";
import { IMainBudget } from '@interfaces/screens/main-budget.interface';
import { ILang} from "@models/*";
import { useSelector } from "react-redux";
import { BudgetService, IBudgetService } from "@services/proyecta/budget.service";
import { String, Utilities, moment, Enums, Dictionary, Constants} from "@utils";
import { dxDataGridColumn } from "devextreme/ui/data_grid";
import { IDataGridOptions } from "devextreme-react/data-grid";

export class MainProaPresenter extends BasePresenter<any>{
        public currentLabels: Dictionary<string, string>;
    
    constructor(view?: any) {
        super(view);
        this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
    }

    public initialize = () => {
        this.dispatcher(this.context.proaStore.getAllFormMasters());
    }
}